import pathToRegexp from 'path-to-regexp';

/**
 * Safely replaces dynamic path and query parameters in a URL.
 *
 * @param {string} channelId - URL with dynamic path and/or query params.
 * @param {object} channelParams - Values to replace placeholders.
 * @param {boolean} encodeURIComponentForChannelId - Whether to encode replacements.
 * @returns {string} Resolved URL with params filled in.
 */
export default function replaceChannelParameters(
	channelId = '',
	channelParams = {},
	encodeURIComponentForChannelId = true
) {
	const encode =
		encodeURIComponentForChannelId !== true || typeof globalThis.encodeURIComponent !== 'function'
			? str => str
			: globalThis.encodeURIComponent;

	const params = channelParams === null ? {} : channelParams;
	const [pathPart, queryPart] = channelId.split('?');

	let basePath = pathPart;
	try {
		basePath = pathToRegexp.compile(pathPart, {validate: false})(params, {encode});
	} catch {
		basePath = pathPart;
	}

	if (!queryPart) return basePath;

	const searchParams = new URLSearchParams(queryPart);
	for (const [key, value] of searchParams) {
		searchParams.set(
			key,
			value.replace(/:([a-zA-Z0-9_]+)/g, (_, paramKey) =>
				Object.prototype.hasOwnProperty.call(params, paramKey)
					? encode(params[paramKey])
					: `:${paramKey}`
			)
		);
	}

	return `${basePath}?${searchParams.toString()}`;
}
